import { UnifiedFile } from ".";
import { uploadFile } from "../uploadFile";
import { ActiveStorageFile } from "./ActiveStorageFile";

export class JSFile implements UnifiedFile {
  #value: File;

  constructor(file: File) {
    this.#value = file;
  }

  get url() {
    return URL.createObjectURL(this.#value);
  }

  async upload() {
    const res = await uploadFile({ file: this.#value });
    if (res.error) {
      return { error: "ファイルアップロードに失敗しました" } as const;
    } else {
      return {
        uploadedFile: new ActiveStorageFile({
          signed_id: res.blob.signed_id,
          name: this.#value.name,
          url: this.url,
          is_image: this.#value.type.startsWith("image/"),
        }),
      };
    }
  }

  get signedId(): string {
    return ""
  }

  get size() {
    return this.#value.size;
  }

  get isNull() {
    return false;
  }

  get value() {
    return this.#value;
  }
}
